import config from 'js/app/config';

export const s3CourseraAssetURL = `${config.url.resource_assets}enterprise/`;

export const addFirstProgramAssets = {
  leftImagePath: 'banner_img_left.png',
  rightImagePath: 'banner_img_right.png',
};

export const createProgramIcon = 'create_program_icon.png';
export const learnersIcon = 'learners_icon.png';
export const planIcon = 'plan_icon.png';
export const courseraLogo = 'coursera_logo.png';
export const footerAvatar = 'lily.png';
